export default __webpack_public_path__ + "d247a62b23744d068ebd61c051bd4d00.svg";